export default {
  componentLoaded: true,
  developmentPositions: [],
  talkrounds: []
};
